export default __webpack_public_path__ + "static/media/Vijayavani4.0a3e60b3.png";